// src/store/six-detail/thunks/exportActivityThunk.ts

import { createAppAsyncThunk } from "@/store/thunks/createAppAsyncThunk";

export const exportActivityThunk = createAppAsyncThunk(
  "sixDetail/exportActivity",
  async(sixId: string, { extra }) => await extra.sixDetailService.exportActivityCsv(sixId)
);
